module.exports = __webpack_public_path__ + "img/MONEY.5b64b91b.svg";